module.exports = __webpack_public_path__ + "img/icon_win.86e27abb.png";